/**
 * MEC-onboarded deals stay out of the intake queue (Lindsay, ADO #1744: "the
 * team does NOT need the MEC groups to stay in the intake queue").
 *
 * Every opportunity Vera's MEC onboarding writes (packages/bff/src/mec/apply.ts)
 * carries a fixed description, and that is the marker read here:
 *
 *   "i360 MEC backfill: created by Vera MEC onboarding on <date> from the i360
 *    workbook, group GB#####. ..."
 *
 * It covers the whole i360 block: the 9/16 backfill ran through the same
 * apply step as its first use, so those opportunities carry it too.
 *
 * Why not something broader:
 *   - Owner Veracity Admin: a systemuser GUID that differs per org, and other
 *     admin-owned deals exist.
 *   - Products Sold "MEC or MC": MEC is a first-class product a rep can sell
 *     (docs/design/mec-onboarding.md), and that sale still needs Intake.
 *   - The onboarding note on the account: the account keeps it forever, so a
 *     later real upsell into a MEC group (say, Rx) would vanish too.
 * A won opportunity the onboarding RECOGNIZED rather than created ("It is this
 * sale") carries no marker and stays in the queue, because somebody else wrote
 * it and it may have been a real Sales Hub sale.
 *
 * Kept free of value imports so it tests without the Dataverse client.
 */

/** Mirrors NOTE_MARKER in packages/bff/src/mec/plan.ts (the SPA cannot import BFF code). */
export const MEC_ONBOARDING_MARKER = 'i360 MEC backfill';

/** The opening of the description apply.ts writes on every opportunity it creates. */
const SIGNATURE = `${MEC_ONBOARDING_MARKER}: created by Vera MEC onboarding`;

/** True when Vera's MEC onboarding created this opportunity. */
export function isMecOnboardedOpportunity(description: string | null | undefined): boolean {
  return typeof description === 'string' && description.includes(SIGNATURE);
}

/** Ids of the MEC-onboarded opportunities among these won ones. */
export function mecOnboardedIds(rows: Array<{ opportunityid: string; description?: string | null }>): Set<string> {
  const out = new Set<string>();
  for (const r of rows) if (isMecOnboardedOpportunity(r.description)) out.add(r.opportunityid);
  return out;
}
